var map = {
	"./Ariosto,_after_-_Peter_III_of_Aragon.jpg": 9558,
	"./Blason-de-CastelnouByTomKrOnWikimedia.jpg": 1145,
	"./Castelnou-depuis-nord-est-vers-1920-Archi-dep-PO217-Jp47.jpg": 3628,
	"./Elisabeth-Thorpes-Cynthia.jpg": 6388,
	"./Interieur-du-chateau-vers-1912_CI-extrait-de-l-ouvrage-du-comte-de-Gironde.jpg": 5620,
	"./James_IIC.jpg": 6570,
	"./Le-chateau-apres-restauration-vers-1903-Coll-privee.jpg": 3499,
	"./M-Dumbar-1912_CI-extrait-ouvrage-Comte-de-Gironde.jpg": 8504,
	"./MJ2_0964.jpg": 5259,
	"./MJ2_1196.jpg": 6759,
	"./POI1.jpg": 5661,
	"./POI10.jpg": 1121,
	"./POI10_LSF.jpg": 1087,
	"./POI11.jpg": 3076,
	"./POI11_LSF.jpg": 7034,
	"./POI12.jpg": 8355,
	"./POI12_LSF.jpg": 5677,
	"./POI13.jpg": 5190,
	"./POI13_LSF.jpg": 3088,
	"./POI14.jpg": 3005,
	"./POI1_LSF.jpg": 1843,
	"./POI2.jpg": 9730,
	"./POI28.jpg": 7768,
	"./POI29.jpg": 8949,
	"./POI2_LSF.jpg": 324,
	"./POI3.jpg": 1439,
	"./POI30.jpg": 7567,
	"./POI31.jpg": 1186,
	"./POI32.jpg": 5341,
	"./POI33.jpg": 7248,
	"./POI34.jpg": 7411,
	"./POI35.jpg": 2646,
	"./POI36.jpg": 4785,
	"./POI37.jpg": 4836,
	"./POI38.jpg": 6343,
	"./POI39.jpg": 8058,
	"./POI3_LSF.jpg": 7473,
	"./POI4.jpg": 4,
	"./POI40.jpg": 2982,
	"./POI41.jpg": 7747,
	"./POI4_LSF.jpg": 5594,
	"./POI5.jpg": 4337,
	"./POI5_LSF.jpg": 5487,
	"./POI6.jpg": 6582,
	"./POI6_LSF.jpg": 1456,
	"./POI7.jpg": 9715,
	"./POI7_LSF.jpg": 8413,
	"./POI8.jpg": 5256,
	"./POI8_LSF.jpg": 3174,
	"./POI9.jpg": 3125,
	"./POI9_LSF.jpg": 3515,
	"./POI_15_LSF.mp4": 6360,
	"./POI_16_LSF.mp4": 3583,
	"./POI_17_LSF.mp4": 7842,
	"./POI_18_LSF.mp4": 5097,
	"./POI_19_LSF.mp4": 1236,
	"./POI_20_LSF.mp4": 9284,
	"./POI_21_LSF.mp4": 4761,
	"./POI_22_LSF.mp4": 8046,
	"./POI_23_LSF.mp4": 699,
	"./POI_24_LSF.mp4": 6032,
	"./POI_25_LSF.mp4": 3189,
	"./POI_26_LSF.mp4": 6154,
	"./POI_27_LSF.mp4": 5047,
	"./Panorama-vers-la-plaine-du-Roussillon-depuis-le-roc-de-MallorcaSAspord-Mercier-et-NAndr.jpg": 8905,
	"./Philippe_le_Hardi_mg_1694.jpg": 1670,
	"./Tour-de-Castelnou.jpg": 887,
	"./Vue-generale-Castelnou-vers-1878-Coll-privee.jpg": 1424,
	"./app-background-wide.jpg": 9376,
	"./app-background.jpg": 4270,
	"./bird-g35f3dc3c6_1920_rougequeue-noir.jpg": 4409,
	"./bumblebee-g9d974650b-1920-fleurs-arbousier.jpg": 1603,
	"./bupleurum-fruticosum.jpg": 3131,
	"./chapelle-saint-martin-de-camelas.jpg": 2985,
	"./character-Pierre.png": 8497,
	"./character-fricfrac.png": 5178,
	"./character-lea.png": 6690,
	"./character-mesange-huppe.png": 6197,
	"./chateau-castelnou©Emmanuel-Layani-La-Kabane-a-images.jpg": 858,
	"./circaete-jean-le-blanc.jpg": 7986,
	"./common-whitethroat-g4cd9809d6_1920_fauvette.jpg": 8858,
	"./debroussaillage-1-apres.jpg": 6310,
	"./debroussaillage-1-avant.jpg": 1873,
	"./debroussaillage-2-apres.jpg": 7801,
	"./debroussaillage-2-avant.jpg": 7238,
	"./debroussaillage-3-apres.jpg": 1492,
	"./debroussaillage-3-avant.jpg": 5151,
	"./debroussaillage-4-apres.jpg": 2343,
	"./debroussaillage-4-avant.jpg": 764,
	"./debroussaillage-5-apres.jpg": 3778,
	"./debroussaillage-5-avant.jpg": 5917,
	"./debroussaillage-6-apres.jpg": 6421,
	"./debroussaillage-6-avant.jpg": 9090,
	"./empreinte-de-blaireau.jpg": 3155,
	"./empty": 2463,
	"./fleurs-de-laurier-tin.jpg": 6332,
	"./fruits-de-laurier-tin.jpg": 8196,
	"./fruits-pistachier.jpg": 5280,
	"./hibou-petit-duc.jpg": 9027,
	"./home-background.jpg": 4936,
	"./interieur-de-ruche-traditionnelle.jpg": 1230,
	"./jeu_Pierre_question.jpg": 2577,
	"./jeu_chateau_28.jpg": 6449,
	"./jeu_chateau_29.png": 4944,
	"./jeu_chateau_30.jpg": 5202,
	"./jeu_chateau_31.jpg": 3263,
	"./jeu_chateau_32.jpg": 8912,
	"./jeu_chateau_33.jpg": 1133,
	"./jeu_jardin_36.jpg": 931,
	"./jeu_jardin_37.jpg": 5670,
	"./jeu_jardin_38.jpg": 5781,
	"./jeu_jardin_39.jpg": 8168,
	"./jeu_jardin_40.jpg": 7584,
	"./jeu_jardin_41.jpg": 8717,
	"./lezard-oceele.jpg": 9178,
	"./melle-curtis-en-1912.jpg": 4552,
	"./mesange-bleue.jpg": 4980,
	"./mesange-huppee-wirestock.jpg": 4954,
	"./mesange-longue-queue.jpg": 8724,
	"./nerpruns-alaterne.jpg": 3468,
	"./pic-epeiche.jpg": 8280,
	"./pie-grieche-tete-rousse.jpg": 7721,
	"./poi_10_ca.aac": 5000,
	"./poi_10_de.aac": 3221,
	"./poi_10_en.aac": 7005,
	"./poi_10_es.aac": 6592,
	"./poi_10_fr.aac": 9496,
	"./poi_10_nl.aac": 5634,
	"./poi_11_ca.aac": 211,
	"./poi_11_de.aac": 6674,
	"./poi_11_en.aac": 3146,
	"./poi_11_es.aac": 5535,
	"./poi_11_fr.aac": 8475,
	"./poi_11_nl.aac": 9489,
	"./poi_12_ca.aac": 2174,
	"./poi_12_de.aac": 4703,
	"./poi_12_en.aac": 5347,
	"./poi_12_es.aac": 2614,
	"./poi_12_fr.aac": 4474,
	"./poi_12_nl.aac": 352,
	"./poi_13_ca.aac": 8737,
	"./poi_13_de.aac": 2204,
	"./poi_13_en.aac": 7304,
	"./poi_13_es.aac": 37,
	"./poi_13_fr.aac": 4397,
	"./poi_13_nl.aac": 3791,
	"./poi_14_ca.aac": 6460,
	"./poi_14_de.aac": 6489,
	"./poi_14_en.aac": 1345,
	"./poi_14_es.aac": 3708,
	"./poi_14_fr.aac": 3140,
	"./poi_14_nl.aac": 390,
	"./poi_1_ca.aac": 1584,
	"./poi_1_de.aac": 109,
	"./poi_1_en.aac": 2005,
	"./poi_1_es.aac": 3608,
	"./poi_1_fr.aac": 9264,
	"./poi_1_nl.aac": 5962,
	"./poi_28_ca.aac": 1651,
	"./poi_28_de.aac": 3058,
	"./poi_28_en.aac": 8474,
	"./poi_28_es.aac": 9791,
	"./poi_28_fr.aac": 5371,
	"./poi_28_nl.aac": 7953,
	"./poi_29_ca.aac": 2984,
	"./poi_29_de.aac": 4389,
	"./poi_29_en.aac": 605,
	"./poi_29_es.aac": 4608,
	"./poi_29_fr.aac": 5352,
	"./poi_29_nl.aac": 8930,
	"./poi_2_ca.aac": 6985,
	"./poi_2_de.aac": 900,
	"./poi_2_en.aac": 5600,
	"./poi_2_es.aac": 973,
	"./poi_2_fr.aac": 9445,
	"./poi_2_nl.aac": 9895,
	"./poi_30_ca.aac": 9978,
	"./poi_30_de.aac": 6507,
	"./poi_30_en.aac": 5375,
	"./poi_30_es.aac": 349,
	"./poi_30_fr.aac": 2126,
	"./poi_30_nl.aac": 7084,
	"./poi_31_ca.aac": 2317,
	"./poi_31_de.aac": 7624,
	"./poi_31_en.aac": 9111,
	"./poi_31_es.aac": 7177,
	"./poi_31_fr.aac": 7713,
	"./poi_31_nl.aac": 1019,
	"./poi_32_ca.aac": 6708,
	"./poi_32_de.aac": 5745,
	"./poi_32_en.aac": 5721,
	"./poi_32_es.aac": 3332,
	"./poi_32_fr.aac": 4076,
	"./poi_32_nl.aac": 638,
	"./poi_33_ca.aac": 1855,
	"./poi_33_de.aac": 4142,
	"./poi_33_en.aac": 5174,
	"./poi_33_es.aac": 4224,
	"./poi_33_fr.aac": 7868,
	"./poi_33_nl.aac": 2893,
	"./poi_34_ca.aac": 4150,
	"./poi_34_de.aac": 3047,
	"./poi_34_en.aac": 3883,
	"./poi_34_es.aac": 6782,
	"./poi_34_fr.aac": 2626,
	"./poi_34_nl.aac": 328,
	"./poi_35_ca.aac": 9737,
	"./poi_35_de.aac": 1620,
	"./poi_35_en.aac": 4576,
	"./poi_35_es.aac": 4669,
	"./poi_35_fr.aac": 1397,
	"./poi_35_nl.aac": 7719,
	"./poi_36_ca.aac": 6784,
	"./poi_36_de.aac": 1853,
	"./poi_36_en.aac": 2565,
	"./poi_36_es.aac": 9816,
	"./poi_36_fr.aac": 8992,
	"./poi_36_nl.aac": 4778,
	"./poi_37_ca.aac": 4411,
	"./poi_37_de.aac": 5818,
	"./poi_37_en.aac": 9746,
	"./poi_37_es.aac": 7863,
	"./poi_37_fr.aac": 995,
	"./poi_37_nl.aac": 3673,
	"./poi_38_ca.aac": 898,
	"./poi_38_de.aac": 9955,
	"./poi_38_en.aac": 7671,
	"./poi_38_es.aac": 9554,
	"./poi_38_fr.aac": 5910,
	"./poi_38_nl.aac": 196,
	"./poi_39_ca.aac": 3461,
	"./poi_39_de.aac": 6352,
	"./poi_39_en.aac": 4492,
	"./poi_39_es.aac": 2737,
	"./poi_39_fr.aac": 8681,
	"./poi_39_nl.aac": 2451,
	"./poi_3_ca.aac": 1590,
	"./poi_3_de.aac": 3303,
	"./poi_3_en.aac": 2827,
	"./poi_3_es.aac": 5534,
	"./poi_3_fr.aac": 9666,
	"./poi_3_nl.aac": 536,
	"./poi_40_ca.aac": 8013,
	"./poi_40_de.aac": 4264,
	"./poi_40_en.aac": 9876,
	"./poi_40_es.aac": 2249,
	"./poi_40_fr.aac": 3409,
	"./poi_40_nl.aac": 7771,
	"./poi_41_ca.aac": 5866,
	"./poi_41_de.aac": 8731,
	"./poi_41_en.aac": 3679,
	"./poi_41_es.aac": 8618,
	"./poi_41_fr.aac": 2510,
	"./poi_41_nl.aac": 8236,
	"./poi_4_ca.aac": 1263,
	"./poi_4_de.aac": 7518,
	"./poi_4_en.aac": 8982,
	"./poi_4_es.aac": 8035,
	"./poi_4_fr.aac": 7247,
	"./poi_4_nl.aac": 5837,
	"./poi_5_ca.aac": 676,
	"./poi_5_de.aac": 209,
	"./poi_5_en.aac": 4057,
	"./poi_5_es.aac": 7924,
	"./poi_5_fr.aac": 4460,
	"./poi_5_nl.aac": 7694,
	"./poi_6_ca.aac": 781,
	"./poi_6_de.aac": 2968,
	"./poi_6_en.aac": 8212,
	"./poi_6_es.aac": 4073,
	"./poi_6_fr.aac": 1057,
	"./poi_6_nl.aac": 587,
	"./poi_7_ca.aac": 1130,
	"./poi_7_de.aac": 6043,
	"./poi_7_en.aac": 7439,
	"./poi_7_es.aac": 5498,
	"./poi_7_fr.aac": 30,
	"./poi_7_nl.aac": 8940,
	"./poi_8_ca.aac": 7728,
	"./poi_8_de.aac": 6754,
	"./poi_8_en.aac": 1930,
	"./poi_8_es.aac": 223,
	"./poi_8_fr.aac": 2155,
	"./poi_8_nl.aac": 7761,
	"./poi_9_ca.aac": 3768,
	"./poi_9_de.aac": 3093,
	"./poi_9_en.aac": 9293,
	"./poi_9_es.aac": 4896,
	"./poi_9_fr.aac": 984,
	"./poi_9_nl.aac": 3970,
	"./pouillot-de-bonelli.jpg": 2146,
	"./roitelet-triple-bandeau.jpg": 8322,
	"./ruche-bee-beekeeping.jpg": 6912,
	"./ruines-de-castelnou-prises-vers-1877-1878-arch-dep.png": 3141,
	"./souche_incendiee.jpg": 4176,
	"./strawberry-tree-ga6301a639_1920-arbousier-fruits.jpg": 888,
	"./tour1.jpg": 8885,
	"./tour2.jpg": 1034,
	"./tour5.jpg": 7497,
	"./tour6.jpg": 1550,
	"./tour_2.mp3": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8458;